import React from 'react';
import AccountAvatarTrigger from '../avatars/AccountAvatarTrigger';
import AdminSenderName from './AdminSenderBadge';
import { appendBubbleFormatClassName } from './messageBubbleClassUtils';

export function buildGroupMessageRowViewModel({
  message,
  presentation,
  isSelf,
  variant = 'plain',
  selfBubbleClass,
  otherBubbleClass,
  timeLabel = '',
  activeAnchorMessageId,
  anchorClassName = 'is-anchor-hit',
  avatarClassName,
  avatarClickableClassName = '',
  avatarFallbackClassName,
  avatarFallbackStyle,
  avatarAlt = '',
  onAvatarClick,
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
}) {
  const bubbleClassName = appendBubbleFormatClassName(
    isSelf ? selfBubbleClass : otherBubbleClass,
    message?.message_format,
  );
  const showAvatar = !isSelf && presentation?.showAvatar !== false;
  const showSender = !isSelf && presentation?.showSender !== false;
  const adminFallbackClassName =
    presentation?.isAdminSender && !presentation?.avatarUrl ? 'is-admin' : '';
  const adminIdentityClassName = presentation?.isAdminSender ? 'is-admin-identity' : '';
  const resolvedAvatarClassName = [avatarClassName, adminFallbackClassName, adminIdentityClassName].filter(Boolean).join(' ');

  const avatarNode = showAvatar ? (
    <AccountAvatarTrigger
      className={resolvedAvatarClassName}
      clickableClassName={avatarClickableClassName}
      title={presentation?.senderName}
      imageUrl={presentation?.avatarUrl}
      imageAlt={avatarAlt || presentation?.senderName || ''}
      style={presentation?.avatarStyle}
      fallback={
        avatarFallbackClassName ? (
          <span className={avatarFallbackClassName} style={avatarFallbackStyle}>
            {presentation?.avatarInitial}
          </span>
        ) : (
          <span>{presentation?.avatarInitial}</span>
        )
      }
      onClick={onAvatarClick}
    />
  ) : null;
  const metaExtra =
    presentation?.showAdminSenderMeta && presentation?.senderName ? (
      <span className="chat-message-row__senderMeta">
        <span className="chat-message-row__senderMetaName">{presentation.senderName}</span>
      </span>
    ) : null;

  return {
    variant,
    messageId: message?.id,
    isSelf,
    senderName: presentation?.senderName,
    senderContent: presentation?.isAdminSender ? <AdminSenderName name={presentation?.senderName} /> : null,
    showSender,
    readCount: presentation?.readCount,
    timeLabel,
    metaExtra,
    bubbleClassName,
    anchorActive: Boolean(
      activeAnchorMessageId && String(activeAnchorMessageId) === String(message?.id),
    ),
    anchorClassName,
    avatarNode,
    onContextMenu,
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
    onTouchMove,
  };
}

export function buildGroupMessageContentProps({
  message,
  presentation,
  onImageClick,
  onMentionClick,
  fileVariant = 'simple',
}) {
  return {
    format: message?.message_format || 'text',
    text: message?.content || '',
    mentions: Array.isArray(message?.mentions) ? message.mentions : [],
    onMentionClick,
    imageSrc: presentation?.imageUrl,
    imageWidth: message?.image_width,
    imageHeight: message?.image_height,
    onImageClick: presentation?.hasMissingImageStorage ? null : onImageClick,
    imageGroupItems: presentation?.imageGroupItems,
    onImageGroupOpen: (item) => {
      if (typeof onImageClick === 'function') onImageClick(item);
    },
    imageUnavailableText: presentation?.hasMissingImageStorage
      ? '画像データが見つかりません。'
      : undefined,
    fileUrl: presentation?.fileUrl,
    fileName: message?.file_original_name || message?.file_file_name || '',
    fileVariant,
    fileCanDownload: presentation?.hasMissingFileStorage ? false : undefined,
    fileDisabledText: presentation?.hasMissingFileStorage
      ? 'ファイルデータが見つかりません。'
      : undefined,
  };
}
